export const SESSION_DISMISS_KEY = 'dismiss-resume-banner-';
export const PERMANENT_DISMISS_KEY = 'hide-resume-banner-';
export const LAST_STEP_KEY = 'common-app-last-step-';
export const VISITED_STEPS_KEY = 'common-app-visited-steps-';
export const APP_ACTIVE_KEY = 'common-app-active';
/** Set when Rails hands off with ?entry=onboarding, until the wizard reads it. */
export const ONBOARDING_ENTRY_KEY = 'common-app-onboarding-entry';
/** The application whose Start or Continue this wizard visit has sent. */
export const ENTRY_TRACKED_KEY = 'common-app-entry-tracked';

/**
 * Padding of the step content box, in theme spacing units. Full-bleed
 * content on phones cancels the xs value with a negative margin, so keep
 * them in sync through this constant.
 */
export const STEP_GUTTER = { xs: 2, sm: 3, md: 4 } as const;

export const BUSINESS_TYPES = {
  SOLE_PROPRIETOR: 'sole_proprietor',
  GENERAL_PARTNERSHIP: 'general_partnership',
  LIMITED_PARTNERSHIP: 'limited_partnership',
  LLC: 'llc',
  S_CORP: 's_corp',
  C_CORP: 'c_corp',
  NON_PROFIT: 'non_profit',
  B_CORP: 'b_corp',
  PROFESSIONAL_CORP: 'professional_corp',
} as const;

export const BUSINESS_TYPE_LABELS: Record<string, string> = {
  [BUSINESS_TYPES.SOLE_PROPRIETOR]: 'Sole Proprietorship',
  [BUSINESS_TYPES.GENERAL_PARTNERSHIP]: 'General Partnership',
  [BUSINESS_TYPES.LIMITED_PARTNERSHIP]: 'Limited Partnership (LP)',
  [BUSINESS_TYPES.LLC]: 'LLC',
  [BUSINESS_TYPES.S_CORP]: 'S-Corp',
  [BUSINESS_TYPES.C_CORP]: 'C-Corp',
  [BUSINESS_TYPES.NON_PROFIT]: 'Non-Profit',
  [BUSINESS_TYPES.B_CORP]: 'B-Corp',
  [BUSINESS_TYPES.PROFESSIONAL_CORP]: 'Professional Corp (PC)',
};

export function isNonProfitApplication(
  businessType: string | undefined,
): boolean {
  return businessType === BUSINESS_TYPES.NON_PROFIT;
}

export function isPartnershipApplication(
  businessType: string | undefined,
): boolean {
  return (
    businessType === BUSINESS_TYPES.GENERAL_PARTNERSHIP ||
    businessType === BUSINESS_TYPES.LIMITED_PARTNERSHIP
  );
}

export const MAXIMUM_OWNERS = 4;

export const BENEFICIAL_OWNER_THRESHOLD = 25;

export const BUSINESS_ROLE_OPTIONS = [
  { value: 'Founder', label: 'Founder' },
  { value: 'Owner', label: 'Owner' },
  { value: 'Partner', label: 'Partner' },
  { value: 'Officer', label: 'Officer' },
  { value: 'Director', label: 'Director' },
  { value: 'Manager', label: 'Manager' },
  { value: 'Employee', label: 'Employee' },
];

export function getMaximumOwners(_businessType: string | undefined): number {
  return MAXIMUM_OWNERS;
}
